import React from 'react'
import check from '../../assets/icons/check.svg'
import eye from '../../assets/icons/eye.svg'
import download from '../../assets/icons/download.svg'

function QueriesTable() {
  return (
    <table
      className="min-w-full overflow-hidden"
      style={{
        border: '1px solid #999',
        borderRadius: '20px',
        borderSpacing: '0',
      }}
    >
      <thead className="thead">
        <tr className="table-head">
          <th
            scope="col"
            className="w-[200px]"
            style={{ borderBottom: '1px solid #999' }}
          >
            Sr No.
          </th>
          <th
            scope="col"
            className="text-start w-[300px] px-3"
            style={{ borderBottom: '1px solid #999' }}
          >
            Date
          </th>
          <th
            scope="col"
            className="text-start w-[550px] px-3"
            style={{ borderBottom: '1px solid #999' }}
          >
            Query
          </th>
          <th
            scope="col"
            className="text-start w-[200px] px-3"
            style={{ borderBottom: '1px solid #999' }}
          >
            Client name
          </th>
          <th
            scope="col"
            className="text-start w-[200px] px-3"
            style={{ borderBottom: '1px solid #999' }}
          >
            Status
          </th>
          <th
            scope="col"
            className="text-center w-[150px] px-3"
            style={{ borderBottom: '1px solid #999' }}
          >
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {Array(5)
          .fill()
          .map((elem, index) => (
            <tr key={index}>
              <td
                className="px-6 py-4 whitespace-nowrap"
                style={index !== 4 ? { borderBottom: '1px solid #999' } : {}}
              >
                <div className="flex justify-center items-center">
                  <div className="flex-shrink-0 serial-number flex items-center h-10 w-10">
                    {index + 1}
                  </div>
                </div>
              </td>
              <td
                className="text-start table-date whitespace-nowrap px-3"
                style={index !== 4 ? { borderBottom: '1px solid #999' } : {}}
              >
                23rd of March, 2024
              </td>

              <td
                className="cursor-pointer whitespace-nowrap table-order px-3"
                style={index !== 4 ? { borderBottom: '1px solid #999' } : {}}
              >
                Payment Issues
              </td>
              <td
                className="table-buyer whitespace-nowrap text-sm text-gray-500 px-3"
                style={index !== 4 ? { borderBottom: '1px solid #999' } : {}}
              >
                Chad Miller
              </td>
              <td
                className="table-status whitespace-nowrap text-sm text-gray-500 px-3"
                style={index !== 4 ? { borderBottom: '1px solid #999' } : {}}
              >
                Pending
              </td>
              <td
                className="px-6 py-4 text-center whitespace-nowrap cursor-pointer  text-sm font-medium"
                style={index !== 4 ? { borderBottom: '1px solid #999' } : {}}
              >
                <div className="flex gap-x-3">
                  <img src={check} alt="check" />
                  <img src={eye} alt="eye" />
                  <img src={download} alt="download" />
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}

export default QueriesTable
